import { EFactsheetTabs } from '../enums/EFactsheetTabs';
import { PageRoutes } from '../enums/enums';

export const coMultifundFactsheetTabs = {
  [EFactsheetTabs.OVERVIEW]: { dictKey: 'globalFactsheet', path: PageRoutes.PUBLIC_FACTSHEET_INDEX },
  [EFactsheetTabs.PERFORMANCE]: { dictKey: 'fsovP2Performance', path: PageRoutes.PUBLIC_FACTSHEET_PERFORMANCE }
};
